import axios from 'axios'

export default {
  async getMatchingStockCars(configCode, requiredMatches) {
    // interface requiredMatches {
    //   trimline?: Boolean
    //   engine?: Boolean
    //   transmission?: Boolean
    //   interior?: Boolean
    //   color?: Boolean
    //   carStatus?: 'onLocation' | 'inTransport' | 'planned'
    //   options?: String[]
    // }
    try {
      let response = await axios.post(`/StockCarMatch/${configCode}`, requiredMatches)
      return Promise.resolve(response.data)
    } catch (e) {
      console.log(e)
      return Promise.reject(e)
    }
  },
}
